import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "payment_entry"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = {
    key: 0,
    class: "register-payment-error"
};
const _hoisted_6 = {
    key: 0,
    class: "register-payment-note"
};
const _hoisted_7 = {
    key: 1,
    class: "register-payment-guide"
};
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import swal from 'sweetalert';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import StripeForm from '@component/PaymentForm.vue';
/**
 * 新規会員登録（相談者・有料プラン）の支払方法登録ステップ
 *
 * - この時点では会員登録されていない（本登録は決済確定と同時）
 * - 画面表示時に支払方法登録モーダルを自動で開く。閉じた場合は未登録のまま、
 *   案内ボックスの「支払い登録」（モーダル再表示）か「プラン選択」（入力画面へ戻る）を選ぶ
 *   （ボタンは他画面と同じ .bt_box の丸ボタン。プラン選択は bt_back＝グレー＋左矢印）
 * - 決済に失敗した場合はモーダル内でやり直す
 * - 3DS 認証から戻ってきて失敗していた場合（認証失敗・3DS 後のカード拒否）は error が渡されるので、
 *   モーダルを開いた上にダイアログで表示し、別のカードを入力できる状態にする
 */
const IDLE_LIMIT_MS = 60 * 60 * 1000;
export default /*@__PURE__*/ _defineComponent({
    __name: 'register_payment',
    props: {
        common: {},
        plan_name: {},
        amount: {},
        is_half: { type: Boolean },
        token: {},
        email: {},
        error: {},
        auto_open: { type: Boolean },
        captured: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        // jquery modal プラグインがクリックを拾う非表示のアンカー（モーダルを開くためだけに使う）
        const modalOpener = ref();
        const openModal = () => {
            var _a;
            (_a = modalOpener.value) === null || _a === void 0 ? void 0 : _a.click();
        };
        const onCanceled = () => {
            // 意図的にモーダルを閉じた: 未登録のまま案内ボックスで待機（常時表示なので何もしない）
        };
        const onFailed = () => {
            // モーダル内でやり直すので何もしない
        };
        // モーダル内の決済エラー（PaymentForm.vue の showError）と同じ見た目で表示する
        const showErrorDialog = (message) => {
            return swal({
                title: '確認',
                text: message,
                icon: 'warning',
                buttons: {
                    ok: {
                        text: 'OK',
                        className: 'timeout-ok-btn',
                    },
                },
            });
        };
        const onClickPlanSelect = () => {
            Inertia.get(route('questioner.register.create'), {
                token: props.token,
                email: props.email,
            });
        };
        // 放置タイマー: 1 時間操作が無ければ非会員ホームへ戻す
        // （放置したオーソリは毎時バッチが 60 分超で cancel するので、それに合わせる。セッション自体はサーバ側の期限に任せる）
        let idleTimer = null;
        const resetIdleTimer = () => {
            if (idleTimer)
                clearTimeout(idleTimer);
            idleTimer = setTimeout(() => {
                window.location.href = route('home');
            }, IDLE_LIMIT_MS);
        };
        const idleEvents = ['mousedown', 'keydown', 'touchstart', 'scroll'];
        onMounted(() => {
            resetIdleTimer();
            idleEvents.forEach((ev) => window.addEventListener(ev, resetIdleTimer, { passive: true }));
            nextTick(() => {
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
                if (props.auto_open) {
                    openModal();
                    // 3DS 戻りなどのエラーはモーダルの上にダイアログで知らせる（ページ上部の赤枠はモーダルに隠れるため）
                    if (props.error) {
                        showErrorDialog(props.error);
                    }
                }
            });
        });
        onUnmounted(() => {
            if (idleTimer)
                clearTimeout(idleTimer);
            idleEvents.forEach((ev) => window.removeEventListener(ev, resetIdleTimer));
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[4] || (_cache[4] = _createElementVNode("h2", null, "支払方法登録", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                (props.error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createElementVNode("span", null, _toDisplayString(props.error), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-start" }, [
                                    _createElementVNode("h4", { style: { "text-align": "start" } }, "お申込み内容")
                                ], -1)),
                                _createElementVNode("form", null, [
                                    _createElementVNode("dl", null, [
                                        _cache[0] || (_cache[0] = _createElementVNode("dt", null, "料金プラン", -1)),
                                        _createElementVNode("dd", null, _toDisplayString(props.plan_name) + "プラン", 1),
                                        _cache[1] || (_cache[1] = _createElementVNode("dt", null, "初月のお支払い", -1)),
                                        _createElementVNode("dd", null, [
                                            _createTextVNode(_toDisplayString(props.amount.toLocaleString()) + "円(税込) ", 1),
                                            (props.is_half)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "※16日以降のお申込みのため初月は半額です"))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("a", {
                                    class: "modal_win",
                                    "data-target": "payment-modal",
                                    ref_key: "modalOpener",
                                    ref: modalOpener,
                                    style: { "display": "none" }
                                }, null, 512),
                                (!props.captured)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _cache[2] || (_cache[2] = _createElementVNode("p", null, [
                                            _createTextVNode(" 支払方法が登録されていないため、会員登録はまだ完了していません。"),
                                            _createElementVNode("br"),
                                            _createTextVNode(" 有料プランで登録する場合は「支払い登録」を、プランを変更する場合は「プラン選択」を押してください。 ")
                                        ], -1)),
                                        _createElementVNode("form", null, [
                                            _createElementVNode("div", { class: "bt_box clear" }, [
                                                _createElementVNode("ul", null, [
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("button", {
                                                            type: "button",
                                                            class: "bt_back",
                                                            onClick: onClickPlanSelect
                                                        }, "プラン選択")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("button", {
                                                            type: "button",
                                                            onClick: openModal
                                                        }, "支払い登録")
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ]),
                _createElementVNode("form", null, [
                    _createVNode(StripeForm, {
                        "store-url": _ctx.route('questioner.register.payment.store'),
                        onCanceled: onCanceled,
                        onFailed: onFailed
                    }, null, 8, ["store-url"])
                ])
            ]));
        };
    }
});
